<template>
	<Col :span="24">
		<VerticalLayout>
			<TypographyTitle :level="4">{{ $t('settings.about.performanceSubHeader') }}</TypographyTitle>
			<Card :bordered="false">
				<PerformanceDisplay />
			</Card>
			<TypographyTitle :level="4">{{ $t('settings.about.versionHistorySubHeader') }}</TypographyTitle>
			<Card :bordered="false">
				<VersionHistory />
			</Card>
			<TypographyTitle :level="4">{{ $t('settings.about.statsAggregationSubHeader') }}</TypographyTitle>
			<Card :bordered="false">
				<StatsAggregationDisplay />
			</Card>
			<TypographyTitle :level="4">{{ $t('settings.about.processMemorySubHeader') }}</TypographyTitle>
			<Card :bordered="false">
				<ProcessMemoryDisplay />
			</Card>
		</VerticalLayout>
	</Col>
</template>

<script>
import { Col, TypographyTitle, Card } from 'ant-design-vue';

import VerticalLayout from '@/components/common/VerticalLayout';

import PerformanceDisplay from '@/components/settings/PerformanceDisplay';
import VersionHistory from '@/components/settings/VersionHistory';
import ProcessMemoryDisplay from '@/components/settings/ProcessMemoryDisplay';
import StatsAggregationDisplay from '@/components/settings/StatsAggregationDisplay';

export default {
	components: {
		Col,
		VerticalLayout,
		TypographyTitle, Card,
		PerformanceDisplay,
		VersionHistory,
		ProcessMemoryDisplay,
		StatsAggregationDisplay,
	},
	setup() {
		return {}
	},
}
</script>
